var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"section-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('Cards',{attrs:{"contents":_vm.contents,"limit":_vm.limit ? _vm.limit : null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }